/** FlowContainer registration: the parser. `./index.r3f` registers the render side. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseFlowContainer } from './parser';
const flowContainerRegistration = {
    typeName: 'FlowContainer',
    parser: parseFlowContainer,
};
nodeRegistry.register(flowContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map